import { Box } from "@mui/material";
import React, { useState } from "react";
import { getUserDetails } from "../../utils/helpers";
import AdminDashboard from "./AdminDashboard";
import FinanceDashboard from "./FinanceDashboard";
import CCRDashboard from "./CCRDashboard";
import UserProfile from "../Users/UserProfile3";
import { useSelector } from "react-redux";

const Dashboard = () => {
  const loggedInUser = useSelector((state) => state.auth.user);

  const getDashboard = () => {
    switch (loggedInUser?.role) {
      case "admin":
        return <AdminDashboard />;
      case "finance":
        return <AdminDashboard />;
      case "ccr":
        return <AdminDashboard />;
      default:
        return <UserProfile />;
    }
  };

  return <Box>{getDashboard()}</Box>;
};

export default Dashboard;
